import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    PARAGRAPH, ITEM,
    OUTSIDE, INSIDE,
} from "const"
import {
    StoreType,
    setCcLibraryItemMenu,
    setCcLibraryHeadingMenu,
} from "client/store"
import { TableGroupedIds, TableNestedIds } from "client/components"
import {
    ParagraphListWrapper,
    ParagraphWrapper,
    Paragraph,
    ParagraphCollapseControl,
    ParagraphDetails,
    ParagraphTitle,
    ParagraphContent,
    ItemListWrapper,
    ItemWrapper,
    Item,
    ItemDetails,
    ItemPublicId,
    ItemData,
    MenuButton,
} from "./styled"
import {
    onMouseDown,
    onMouseEnter,
} from "./move"

const COLLAPSED = "collapsed"

interface NestedListProps {
    editAccess: boolean
}
const NestedList = ({
    editAccess,
}: NestedListProps) => {
    const nested = useSelector((state: StoreType) => state.ccLibraryItem.itemGroupedIds)

    if (!nested) return null
    return (
        <ParagraphListWrapper>
            <ParagraphWrapper>
                <ParagraphContent offsetLeft={false}>
                    <ItemList
                        nested={nested.nestedIds}
                        editAccess={editAccess}
                    />
                    <ParagraphList
                        parentNested={nested}
                        editAccess={editAccess}
                    />
                </ParagraphContent>
            </ParagraphWrapper>
        </ParagraphListWrapper>
    )
}
export default NestedList


interface ParagraphListProps {
    parentNested: TableGroupedIds
    editAccess: boolean
}
const ParagraphList = ({
    parentNested,
    editAccess,
}: ParagraphListProps) => {
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const headingList = useSelector((state: StoreType) => state.ccLibraryHeading.headingList)
    const itemList = useSelector((state: StoreType) => state.ccLibraryItem.itemList)
    const dispatch = useDispatch()

    const [onClick, setOnClick] = useState(false)

    return (
        <ParagraphListWrapper>
            {
                parentNested.nestedGroupedIds.map((nestedGroup) => {
                    const { groupId } = nestedGroup
                    const heading = headingList[groupId]

                    if (!heading) return null
                    return (
                        <ParagraphWrapper key={groupId}>
                            <Paragraph>
                                <ParagraphCollapseControl
                                    onClick={(e) => {
                                        const paragraphWrapper = e.currentTarget.closest(ParagraphWrapper)
                                        const collapsed = paragraphWrapper.classList.contains(COLLAPSED)

                                        if (collapsed) paragraphWrapper.classList.remove(COLLAPSED)
                                        else paragraphWrapper.classList.add(COLLAPSED)
                                    }}
                                />
                                <ParagraphDetails>
                                    <MenuButton
                                        onMouseDown={(e) => {
                                            // onMouseDown and onClick doesn't work together
                                            setOnClick(true)
                                            setTimeout(() => setOnClick(false), 200)

                                            if (!editAccess) return
                                            onMouseDown(
                                                e,
                                                heading,
                                                PARAGRAPH,
                                                set,
                                                headingList,
                                                itemList,
                                                dispatch,
                                            )
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!editAccess) return
                                            onMouseEnter(
                                                e,
                                                heading,
                                                PARAGRAPH,
                                                OUTSIDE,
                                                parentNested.nestedGroupedIds,
                                                parentNested.nestedIds,
                                            )
                                        }}
                                        onMouseUp={(e) => {
                                            if (!onClick) return
                                            dispatch(setCcLibraryHeadingMenu(heading.id, e.currentTarget as HTMLElement))
                                            dispatch(setCcLibraryItemMenu(null, null))
                                        }}
                                    />
                                    <ParagraphTitle onMouseEnter={(e) => {
                                        if (!editAccess) return
                                        onMouseEnter(
                                            e,
                                            heading,
                                            PARAGRAPH,
                                            INSIDE,
                                            nestedGroup.nestedGroupedIds,
                                            nestedGroup.nestedIds,
                                        )
                                    }}
                                    >
                                        {heading.title}
                                    </ParagraphTitle>
                                </ParagraphDetails>
                            </Paragraph>

                            <ParagraphContent offsetLeft>
                                <ItemList
                                    nested={nestedGroup.nestedIds}
                                    editAccess={editAccess}
                                />
                                <ParagraphList
                                    parentNested={nestedGroup}
                                    editAccess={editAccess}
                                />
                            </ParagraphContent>
                        </ParagraphWrapper>
                    )
                })
            }
        </ParagraphListWrapper>
    )
}


interface ItemListProps {
    nested: readonly TableNestedIds[]
    editAccess: boolean
}
const ItemList = ({
    nested,
    editAccess,
}: ItemListProps) => {
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const headingList = useSelector((state: StoreType) => state.ccLibraryHeading.headingList)
    const itemList = useSelector((state: StoreType) => state.ccLibraryItem.itemList)
    const dispatch = useDispatch()

    const [onClick, setOnClick] = useState(false)

    return (
        <ItemListWrapper>
            {
                nested.map((nestedItem) => {
                    const { id } = nestedItem
                    const item = itemList[Number(id)]

                    return (
                        <ItemWrapper key={id}>
                            <Item>
                                <MenuButton
                                    onMouseDown={(e) => {
                                        // onMouseDown and onClick doesn't work together
                                        setOnClick(true)
                                        setTimeout(() => setOnClick(false), 200)

                                        if (!editAccess) return
                                        onMouseDown(
                                            e,
                                            item,
                                            ITEM,
                                            set,
                                            headingList,
                                            itemList,
                                            dispatch,
                                        )
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!editAccess) return
                                        onMouseEnter(
                                            e,
                                            item,
                                            ITEM,
                                            OUTSIDE,
                                            null,
                                            nested,
                                        )
                                    }}
                                    onMouseUp={(e) => {
                                        if (!onClick) return
                                        dispatch(setCcLibraryItemMenu(item.id, e.currentTarget as HTMLElement))
                                        dispatch(setCcLibraryHeadingMenu(null, null))
                                    }}
                                />
                                <ItemDetails onMouseEnter={(e) => {
                                    if (!editAccess) return
                                    onMouseEnter(
                                        e,
                                        item,
                                        ITEM,
                                        INSIDE,
                                        null,
                                        nestedItem.nestedIds,
                                    )
                                }}
                                >
                                    <ItemPublicId>{item && item.publicId}</ItemPublicId>
                                    <ItemData>{item && item.compliantItem}</ItemData>
                                </ItemDetails>
                            </Item>

                            <ItemList
                                nested={nestedItem.nestedIds}
                                editAccess={editAccess}
                            />
                        </ItemWrapper>
                    )
                })
            }
        </ItemListWrapper>
    )
}
